/** Figures on the planner, as people read them. */

export const whole = (n: number | null | undefined): string =>
  n === null || n === undefined || Number.isNaN(n) ? '—' : Math.round(n).toLocaleString('en-US');

export const oneDecimal = (n: number | null | undefined): string =>
  n === null || n === undefined || Number.isNaN(n)
    ? '—'
    : (Math.round(n * 10) / 10).toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const percent = (n: number | null | undefined): string => (n === null || n === undefined ? '—' : `${oneDecimal(n)}%`);

/** "Mon, Tue and Sat". */
export function listDays(days: string[]): string {
  if (days.length <= 1) return days.join('');
  return `${days.slice(0, -1).join(', ')} and ${days[days.length - 1]}`;
}

/** "an agent" / "6 agents". */
export const agentsLabel = (n: number): string => (n === 1 ? '1 agent' : `${whole(n)} agents`);

/** Two places, so a column divided by another on screen gives the number shown. */
export const twoDecimal = (n: number | null | undefined): string =>
  n === null || n === undefined || Number.isNaN(n)
    ? '—'
    : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const twoDecimalPercent = (n: number | null | undefined): string =>
  n === null || n === undefined ? '—' : `${twoDecimal(n)}%`;

/** Dollars and cents, for the same reason. */
export const money = (n: number | null | undefined): string =>
  n === null || n === undefined ? '—' : `$${twoDecimal(n)}`;

/** Whole dollars, for figures read at a glance rather than added up. */
export const dollars = (n: number | null | undefined): string =>
  n === null || n === undefined || Number.isNaN(n) ? '—' : `$${whole(n)}`;
